












































































































































import { Component, Vue, BasePage } from "@/common";

import { TwTable } from "@/components";

import { Tree } from "element-ui";

import moment from "moment";

@Component({})
export default class Role extends BasePage {
  private onOpen() {
    this.columnData.splice(0);
    this.buttonData.splice(0);
  }

  editing: boolean = false;

  allotShow: boolean = false;

  userShow: boolean = false;

  saveMask: boolean = false;

  isModify: boolean = false;

  cCode: string = "";

  role = {
    ID: null,
    TenantId: null,
    cCode: "",
    cTitle: "",
    cDesc: "",
    iStatus: 1
  };

  rules = {
    cCode: [
      { required: true, message: "请输入编码", trigger: "blur" },
      { min: 2, max: 15, message: "长度在 2 到 15 个字符之间", trigger: "blur" }
    ],
    cTitle: [
      { required: true, message: "请输入名称", trigger: "blur" },
      { min: 2, max: 15, message: "长度在 2 到 15 个字符之间", trigger: "blur" }
    ]
  };

  columns = [
    {
      prop: "cCode",
      label: "编码",
      align: "center",
      width: 120,
      attrs: {
        type: "string"
      }
    },
    {
      prop: "cTitle",
      label: "名称",
      align: "center",
      width: 120,
      attrs: {
        type: "string"
      }
    },
    {
      prop: "cDesc",
      label: "描述",
      align: "center",
      width: 180,
      attrs: {
        type: "string"
      }
    },
    {
      prop: "iStatus",
      label: "状态",
      align: "center",
      width: 100,
      attrs: {
        type: "number"
      },
      render: this.renderEnabled
    },
    {
      label: "操作",
      align: "center",
      width: 140,
      render: this.renderOperation
    }
  ];

  //权限分配
  modelData = [];
  modelID = [];
  columnData = [];
  buttonData = [];

  //用户分配
  userList = [];
  titles = ["未分配用户", "已分配用户"];
  value = [];

  get table(): TwTable {
    return this.$refs["roletable"] as TwTable;
  }

  get tree(): Tree {
    return this.$refs["tree"] as Tree;
  }

  get columntree(): Tree {
    return this.$refs["columntree"] as Tree;
  }

  get buttontree(): Tree {
    return this.$refs["buttontree"] as Tree;
  }

  add() {
    this.isModify = false;
    this.editing = true;
    this.resetForm("roleForm");
    // 因为ID未在form表单绑定输入元素,所以resetForm不会重置ID,如果后台需要根据ID做一些判断,可以在这里手动置空
    this.role.ID = null;
  }

  modify() {
    this.isModify = true;
    this.editing = true;
    this.resetForm("roleForm");
    this.loadForm(this.role, this.table.getCurrentRow());
  }

  save() {
    this.isFormValid("roleForm", valid => {
      if (valid) {
        this.saveMask = true;
        this.$http
          .post("Base/Role/Save", { role: this.role })
          .then(res => {
            if (res.data.status === 0) {
              this.saveMask = false;
              this.editing = false;
              this.$message.success("操作成功");
              this.table.reload();
            } else {
              this.saveMask = false;
              this.$message.warning(res.data.msg || "操作失败");
            }
          })
          .catch(err => {
            this.$message.warning(err);
          });
      }
    });
  }

  deleteRows() {
    this.$http
      .post("Base/Role/Delete", {
        delIds: this.table.getSelections().map(item => item.ID)
      })
      .then(res => {
        if (res.data.status === 0) {
          this.$message.success("删除成功");
          this.table.reload();
        } else {
          this.$message.warning(res.data.msg || "操作失败");
        }
      });
  }

  load() {
    this.table.load();
  }

  loadModuleData() {
    this.$http
      .get("Base/Role/GetModuleData", {
        params: {
          ID: this.role.ID
        }
      })
      .then(res => {
        this.modelData = res.data.nodes;
        this.tree.setCheckedKeys(res.data.ids);
      });
  }
  loadColumnData(cCode) {
    this.cCode = cCode;
    this.$http
      .get("/Base/Role/GetColumnData", {
        params: {
          ID: this.role.ID,
          cCode: cCode
        }
      })
      .then(res => {
        this.columnData.splice(0);
        this.columnData.push(res.data.cols);
        this.$nextTick(() => {
          this.columntree.setCheckedKeys(res.data.ids);
        });
      });
  }

  loadButtonData(cCode) {
    this.cCode = cCode;
    this.$http
      .get("/Base/Role/GetButtonData", {
        params: {
          nRoleID: this.role.ID,
          cModuleCode: cCode
        }
      })
      .then(res => {
        this.buttonData.splice(0);
        this.buttonData.push(res.data.btns);
        this.$nextTick(() => {
          this.buttontree.setCheckedKeys(res.data.ids);
        });
      });
  }

  moduleTreeCheck(p1, p2) {
    const roleID = this.role.ID;
    const moduleCodeArr = [];
    p2.checkedNodes.forEach(item => {
      if (item.leaf === true) {
        moduleCodeArr.push(item.cCode);
      }
    });

    this.$http
      .post("/Base/Role/ModuleRoleSet", { moduleCodeArr, roleID })
      .then(res => {
        if (res.data.status !== 0) {
          this.$message.error(`自动保存失败:${res.data.msg}`);
        }
      })
      .catch(err => {
        this.$message.error(`自动保存失败:${err || "未知异常"}`);
      });
  }

  columnTreeChange(p1, p2) {
    const roleID = this.role.ID;
    const fieldArr = [];
    p2.checkedNodes.forEach(item => {
      if (item.leaf === true) {
        fieldArr.push(item.cField);
      }
    });

    this.$http
      .post("/Base/Role/ColumnRoleSet", {
        fieldArr,
        roleID,
        cModuleCode: this.cCode
      })
      .then(res => {
        if (res.data.status !== 0) {
          this.$message.error(`自动保存失败:${res.data.msg}`);
        }
      })
      .catch(err => {
        this.$message.error(`自动保存失败:${err || "未知异常"}`);
      });
  }

  buttonTreeChange(p1, p2) {
    const roleID = this.role.ID;
    const fieldArr = [];
    p2.checkedNodes.forEach(item => {
      if (item.leaf === true) {
        fieldArr.push(item.cField);
      }
    });

    this.$http
      .post("/Base/Role/ButtonRoleSet", {
        fieldArr,
        roleID,
        cModuleCode: this.cCode
      })
      .then(res => {
        if (res.data.status !== 0) {
          this.$message.error(`自动保存失败:${res.data.msg}`);
        }
      })
      .catch(err => {
        this.$message.error(`自动保存失败:${err || "未知异常"}`);
      });
  }

  awardAll() {
    this.roleSet(1);
  }

  revokeAll() {
    this.roleSet(0);
  }

  roleSet(status) {
    const roleID = this.role.ID;
    this.$http
      .post("/Base/Role/RoleSet", { status, roleID })
      .then(res => {
        if (res.data.status !== 0) {
          this.$message.error(`$操作失败:${res.data.msg}`);
        } else {
          this.loadModuleData();
          this.columnData.splice(0);
          this.buttonData.splice(0);
        }
      })
      .catch(err => {
        this.$message.error(`操作失败:${err || "未知异常"}`);
      });
  }

  selectChange(a, b, c) {
    if (a) {
      this.loadColumnData(a.cCode);
      this.loadButtonData(a.cCode);
    } else {
      this.columnData.splice(0);
      this.buttonData.splice(0);
    }
  }

  // 列渲染  使用jsx方式渲染 必须使用函数方式实现 不支持箭头函数和function函数
  renderEnabled(props) {
    switch (props.row.iStatus) {
      case 0:
        return <span style="color:grey">停用</span>;
      case 1:
        return <span style="color:green">启用</span>;
    }
  }

  //权限分配弹出框
  showAllotModal(data) {
    this.role = { ...data };
    this.loadModuleData();
    this.allotShow = true;
  }
  //用户分配弹出框
  showUserModal(data) {
    this.role = { ...data };
    this.loadparent();
    this.loadRoleUserList(this.role.ID);
    this.userShow = true;
  }

  loadparent() {
    this.$http.get("Base/Role/UserGetData").then(res => {
      this.userList.splice(0);
      this.userList.push(...res.data);
    });
  }

  loadRoleUserList(nRoleID) {
    this.$http
      .get("/Base/Role/GetRoleUserList", { params: { nRoleID } })
      .then(res => {
        this.value.splice(0);
        this.value.push(...res.data);
      });
  }
  saveRoleUserList() {
    this.$http
      .post("/Base/Role/SaveRoleUserList", {
        nRoleID: this.role.ID,
        targetKeys: this.value
      })
      .then(res => {
        if (res.data) {
          switch (res.data.status) {
            case 0:
              this.$message.success("保存成功");
              this.userShow = false;
              break;
            default:
              this.$message.error("保存失败,未知状态");
          }
        } else {
          this.$message.error("保存失败,未知状态");
        }
        this.userShow = false;
      })
      .catch(err => {
        this.$message.error(`保存失败:${err}`);
        this.userShow = false;
      });
  }

  // 通过列渲染方式实现之定义列
  renderOperation(props) {
    return (
      <div style="display:inline;">
        <el-tooltip
          content={props.row.iStatus === 1 ? "停用权限" : "启用权限"}
          hide-after={700}
          placement="bottom"
        >
          <el-button
            style="padding:7px;"
            type={props.row.iStatus === 1 ? "danger" : "success"}
            v-show={props.row.iStatus !== 2}
            onClick={() => {
              this.$confirm(
                `确定${props.row.iStatus === 1 ? "停用" : "启用"}当前么?`,
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                }
              )
                .then(() => {
                  props.row.iStatus = props.row.iStatus === 1 ? 0 : 1;
                  this.$http.post("Base/Role/AlterStatus", {
                    iStatus: props.row.iStatus,
                    ID: props.row.ID
                  });
                })
                .catch(() => {});
            }}
          >
            {props.row.iStatus === 1 ? "停" : "启"}
          </el-button>
        </el-tooltip>

        <el-tooltip content="指定权限" hide-after={700} placement="bottom">
          <el-button
            style="padding:7px;"
            type="success"
            icon="el-icon-menu"
            onClick={() => {
              this.showAllotModal(props.row);
              this.loadModuleData();
            }}
          />
        </el-tooltip>
        <el-tooltip content="指定用户" hide-after={700} placement="bottom">
          <el-button
            style="padding:7px;"
            type="success"
            icon="el-icon-user"
            onClick={() => {
              this.showUserModal(props.row);
            }}
          />
        </el-tooltip>
      </div>
    );
  }
}
